module.exports = __webpack_public_path__ + "static/media/mini_txiotesia.820aa962.jpeg";